module.exports={
    btn:{
        "tips_reelect_btn":"Nouvelle image",
        "cancel_btn":"Annuler",
        "continue_dispose":"Images prises en charge haut de gamme",
        "tips_return":"Nouvelle image",
        "tips_upgrade":"Mettre à niveau",
        "tips_yes":"OK",
        "delete":"Supprimer",
        "download":"Télécharger",
        "upload_image":"Télécharger l'image",
        "new_image":"Nouvelle image",
        "save_all":"Enregistrer tous",
        "cancel":"Annulation",
        "save":"Sauvegarder",
        "view_comparison":"Voir la comparaison",
        "hide_comparison":"Masquer la comparaison",
        "previous":"Précédent",
        "next":"Suivant",
        "continue_download":"Enregistrer des images avec des filigranes",
        "present":"Appliquer à cette image",
        "all_wait":"Appliquer aux images en attente",
        "all":"Appliquer à toutes les images",
        "history":"Histoire",
        "login":"Se connecter",
    },
    tips:{
        "please_upgrade":"Votre forfait actuel ne prend pas en charge le téléchargement ou la mise à l'échelle d'images par lots. Veuillez le mettre à niveau pour profiter de plus d'avantages.",
        "errorlistinfo":"Les images XXX sont sélectionnées. Les images XXX sont prises en charge, mais les images XXX ne le sont pas. Les images suivantes ne sont pas prises en charge :",
        "max":"Dépassez la limite maximale de taille d’image de 10 Mo !",
        "max_size":"Dépassez la limite maximale de longueur latérale de l’image de 4 096 px !",
        "continue_dispose":"Images prises en charge haut de gamme",
        "please_multiple":"Veuillez sélectionner le grossissement.",
        "max_multiple":"* Votre image sera agrandie jusqu'à 4K au maximum (le côté le plus long ne dépassera pas 4096px).",
        "title":"Nom",
        "reasons":"Les raisons",
        "upload_type":"Ne pas supporté",
        "used_up":"Le nombre d’images HD enregistrées sans filigrane est épuisé. Veuillez mettre à niveau votre compte. Ou vous pouvez enregistrer des images HD avec des filigranes.",
        "edit_multiple":"Plusieurs images sont téléchargées. Veuillez sélectionner les images dont vous souhaitez modifier le grossissement. Après la sélection, ces images seront mises à l'échelle au nouveau grossissement.",
        "download_confirm":"Certaines images sont encore en cours de traitement. Êtes-vous sûr d'enregistrer toutes les images mises à l'échelle ? Lorsque vous enregistrez la même image à plusieurs reprises, votre nombre d'images enregistrées ne sera plus déduit.",
        "waiting_save":"Certaines images sont encore en cours de traitement. Veuillez enregistrer plus tard.",
        
    },
    header:{
        "title":"Aiseesoft Image Upscaler En Ligne",
        "hd":" Images HD",
        "watermarks":"sans filigrane peut être téléchargé à l'heure actuelle.",
        "view_details":"Voir les détails",
        "loading":"Chargement…",
    },
    content:{
        "failed":"Échoué",
        "completed":"Complété",
        "processing":"Traitement",
        "img_processing":"Traitement…",
        "img_failed":"Échec du traitement",
        "uploading":"Téléchargement",
        "img_uploading":"Téléchargement…",
        "wait_upoading":"En attente de téléchargement…",
        "waiting":"En attendant",
        "img_waiting":"En attendant…",
        "empty":"Vide",
        "magnification":"Grossissement:",
        "drop":"Ou déposez votre image ici pour le mettre à l'échelle et l'améliorer !",
        "original":"Original:",
        "output":"Sortir:",
        img_rendering1:"Votre image a été upscalé.",
        img_rendering2:"Nous travaillons sur le rendu de l'image de haute qualité pour la prévisualisation, veuillez patienter...",
        no_watermark:"Après l'enregistrement, l'image n'a pas de filigrane.",
    },
    "banner_msg":"Choisissez un plan pour l'upscaler d'image",
    "monthly":"MENSUEL",
    "lifetime":"À VIE",
    "choose_plan":"Choisissez votre forfait en fonction du nombre d'images",
    "return_home":"Félicitations! Vous avez effectué la mise à niveau avec succès. Veuillez revenir à la page d'accueil et utiliser ce produit.",
    "congratulations":"Félicitations! Vous avez effectué la mise à niveau avec succès. Les avantages sont liés à l'adresse e-mail que vous avez laissée lors de la mise à niveau. Veuillez utiliser le compte enregistré ou lié à l'adresse e-mail pour",
    "login_benefits":"connectez-vous pour utiliser les avantages",
    "no_registered":". Si vous n'avez pas enregistré ou lié un compte avec l'adresse e-mail, veuillez",
    "register_account":"utiliser l'adresse e-mail pour créer un compte",
    "other_accounts":" ou associez d'autres comptes à cette adresse e-mail pour bénéficier des avantages.",
    "btn_close":"Fermer",
    "free":"Gratuit",
    "btn_get_started":"Commencer",
    "access_to":"Accès à",
    "upscale_images":"Images haut de gamme",
    "up_to":"Jusqu'à",
    "per_image":"par image",
    "resolution_of":"Jusqu'à la résolution de",
    "default_level":"Images haut de gamme au niveau par défaut",
    "image_downloads":"2 téléchargements d'images HD sans filigrane",
    "unlimited_image":"Téléchargements d'images illimités avec filigrane",
    "SHA256_encryption":"Technique de cryptage SHA256",
    "mon":"Mensuel",
    "images":"images",
    "high_resolution":"avec une haute qualité",
    "tax_incl":"Taxe inclu",
    "image":"image",
    "secure_checkout":"Paiement sécurisé",
    "everything":"Tout est gratuit et",
    "upscaling_levels":"Tous les niveaux de mise à l'échelle peuvent être sélectionnés",
    "unlimited_image_without":"Téléchargements d'images illimités sans filigrane",
    "viewable_editing":"L'historique des modifications visible est valable pour",
    "days":"jours",
    "high_level":"Haut niveau",
    "priority_processing":"traitement prioritaire",
    "left":"À vie",
    "resolution":"résolution",


    "history_will":"expirera après",
    "history.days":"Jours",
    "history.hours":"heures",
    "expired":"Expiré",
    "access_to":"Avec l'essai gratuit, vous ne pouvez que",
    "pricing.upload_images":"Importer des images",
    "pricing.under":"sous",
    "pricing.images":"images",
    "pricing.without_watermark":"sans filigrane",
    "pricing.process_images":"Traitez les images jusqu'à",
    "pricing.pixels":"pixels",
    "pricing.enjoy_limited":"Profitez de niveaux premium limités",
    "pricing.download":"Télécharger",
    "pricing.HD_images":"Images HD sans filigrane",
    "pricing.and_you":"Et vous pourriez souffrir de",
    "pricing.slow_upscaling":"mise à l'échelle lente",
    "pricing.lower_priority":"priorité inférieure",
    "pricing.without":"sans filigrane",
    "pricing.tax":"La taxe est incluse dans le prix de vente et sera calculée automatiquement en fonction de votre pays et région. Dans le panier, vous pouvez voir le montant détaillé de la taxe. Le montant de votre paiement final sera le même que le prix affiché.",
    "pricing.you_can":"Avec l'abonnement, vous pouvez",
    "pricing.up_to":"Téléchargez des images jusqu'à",
    "pricing.upscale_images":"Des images haut de gamme avec",
    "pricing.no_watermark":"pas de filigrane",
    "pricing.enhance":"Améliorer",
    "pricing.or_more":"images ou plus",
    "pricing.in_batch":"par lots",
    "pricing.enlarge_images":"Agrandir les images dans",
    "pricing.and":"et",
    "pricing.times_with":"fois sans limite",
    "pricing.enjoy":"Profiter",
    "pricing.of_history":"de la durée de stockage de l'historique",
    "pricing.experience":"Expérience",
    "pricing.fast_upscaling":"mise à l'échelle rapide",
    "pricing.higher_priority":"priorité plus élevée",
    "pricing.early_access":"Accès anticipé aux nouvelles fonctionnalités",
    "pricing.cancel_anytime":"Annuler à tout moment",
    "pricing.lifetime_license":"Avec une licence à vie, vous pouvez",
    "pricing.and_there":"Et il y aura",
    "pricing.no_expiration":"pas de date d'expiration",
    "pricing.unless":"à moins que vous n'épuisez tous les haut de gamme",

    "buynow.pop.credit":"crédit",
    "buynow.pop.credits":"crédits",

    "isUnderequityTip_msg1":"Vous avez sélectionné {%} images pour le traitement par lot, il ne reste pas assez de droits et avantages, vous avez encore besoin de {%} crédits (actuellement il reste {%} crédits), veuillez acheter des droits et avantages pour continuer à traiter les images.",
    "isUnderequityTip_msg2":"Vous avez sélectionné {%} images pour le traitement par lot, il ne reste pas assez de droits et avantages, vous avez encore besoin de {%} crédits (actuellement il reste {%} images), veuillez acheter des droits et avantages pour continuer à traiter les images.",
    "isUnderequityTip_msg3":"Vous avez sélectionné {%} images pour le traitement par lot, il ne reste pas assez de droits et avantages, vous avez encore besoin de {%} crédits (actuellement il reste {%} crédits et {%} images), veuillez acheter des droits et avantages pour continuer à traiter les images.",
    "btn_buy_now":"Acheter",
    "isEquityDepletionTip_msg":"Votre droit et avantage actuel est épuisé, veuillez acheter des droits et avantages pour le traitement par lots.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Forfaits et Tarifs",
    "pricing.banner_content":"Obtenez des crédits AI Photo Editor pour supprimer les arrière-plans d'images, améliorer les images et supprimer des objets des images en ligne ou depuis le bureau.",
    "pricing.best_seller":"Meilleure Vente",
    "pricing.monthly":"Abonnement Mensuel",
    "pricing.credits":"crédits",
    "pricing.lifetime":"À Vie",
    "pricing.note":"Note",
    "pricing.buy_now":"Acheter",
    "pricing.note_content":"Les crédits achetés sont liés à l'adresse e-mail que vous avez saisie dans le panier. Pour utiliser ces crédits, veuillez vous inscrire ou vous connecter en utilisant la même adresse e-mail.",

    "header.buy_more":"Acheter plus",
    "header.available_credits":"Crédits disponibles",
    "header.credits":"crédit(s)"
}